<template>
  <div
    class="left-0 top-0 fixed h-screen w-screen bg-white z-[99999] flex items-center justify-center animate-fade-out"
    style="animation-delay: 2s"
  >
    <div class="md:w-1/2 md:h-1/2 w-2/3 h-2/3 flex flex-col items-center justify-center">
      <HeaderLogo
      DisableAnimation
      class="h-full w-full animate-scale-out"
      style="animation-delay: 2s"
      />
      <div 
      class="text-center font-bold mt-2 animate-scale-out md:text-2xl" 
      style="animation-delay: 2s">
      <Loader/>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderLogo from '@/Header/HeaderLogo.vue';
import Loader from "@/components/Utils/Loader.vue";

export default {
  name: 'LoadingScreen',
  components: {
    HeaderLogo,
    Loader
  },
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.loaded = true;
      setTimeout(() => {
        this.$emit('loaded');
      }, 400);
    }, 2000);
  }
};
</script>